import React from 'react';

import styles from '../Style/PricingComponents.module.scss';

import { ReactComponent as Info } from '../../../../../assets/icon/Info.svg';
import { ReactComponent as Yes } from '../../../../../assets/icon/Done.svg';
import { ReactComponent as No } from '../../../../../assets/icon/Remove.svg';
import { ReactComponent as Plus } from '../../../../../assets/icon/Add.svg';
import { useNavigate } from 'react-router-dom';
import useHomeStore from '../../../../../store/homeStore';

export function TimeSeriesTable() {
  return (
    <div className={styles.timeSeries}>
      <div className={`${styles.title} ${styles.title1}`}>Category</div>
      {/* <div className={`${styles.title} ${styles.title2}`}>Type</div> */}
      <div className={`${styles.title} ${styles.title2}`}></div>
      {/* <div className={`${styles.title} ${styles.title3}`}>Price [EUR/point/year]</div> */}
      <div className={`${styles.title} ${styles.title3}`}></div>

      <div className={`${styles.category} ${styles.cat1}`}>Wave</div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem1}`}>
        <div>
          <div className={styles.itemPrice}>&euro;110</div>
          <div className={styles.itemTitle}>Integrated parameters</div>
        </div>
        <div className={styles.itemSubTitle}></div>
      </div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem2}`}>
        <div>
          <div className={styles.itemPrice}>&euro;200</div>
          <div className={styles.itemTitle}>2D Wave Spectra*</div>
        </div>
        <div className={styles.itemSubTitle}>
          * Price includes integrated parameters
        </div>
      </div>

      <div className={`${styles.category} ${styles.cat2}`}>Ocean</div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem3}`}>
        <div>
          <div className={styles.itemPrice}>&euro;110</div>
          <div className={styles.itemTitle}>Depth-averaged model</div>
        </div>
        <div className={styles.itemSubTitle}></div>
      </div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem4}`}>
        <div>
          <div className={styles.itemPrice}>&euro;300</div>
          <div className={styles.itemTitle}>3D Current Model*</div>
        </div>
        <div className={styles.itemSubTitle}>
          * Current, temperature, and salinity <br />
          at all layers and depth-averaged
        </div>
      </div>

      <div className={`${styles.category} ${styles.cat3}`}>Atmosphere</div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem5}`}>
        <div>
          <div className={styles.itemPrice}>Free</div>
          <div className={styles.itemTitle}>Public re-analyses</div>
        </div>
        <div className={styles.itemSubTitle}></div>
      </div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem6}`}>
        <div>
          <div className={styles.itemPrice}>&euro;110</div>
          <div className={styles.itemTitle}>Downscaled (fx WRF)</div>
        </div>
      </div>
      <div className={styles.sectionContainerFooter}>
        <div>
          <Info className={styles.svg} />
          <p>
            A handling fee of &euro;1,500.- per order is added for standard
            manual data delivery.
          </p>
        </div>
        <div>
          <Info className={styles.svg} />
          <p>The pricing may change at any given time without prior notice. </p>
        </div>
      </div>
    </div>
  );
}

export function MultiPointDiscountGraph() {
  return (
    <div className={styles.discountGraph}>
      <div className={`${styles.discount} ${styles.discount1}`}></div>
      <div className={`${styles.line}`}>
        <div>
          2<sup>nd</sup> Point
        </div>
      </div>
      <div className={`${styles.discount} ${styles.discount2}`}>
        50<sup>%</sup>
      </div>
      <div className={`${styles.line}`}>
        <div>
          3<sup>rd</sup>-9<sup>th</sup> Point
        </div>
      </div>
      <div className={`${styles.discount} ${styles.discount3}`}>
        75<sup>%</sup>
      </div>
      <div className={`${styles.line}`}>
        <div>
          10<sup>th</sup> + Point
        </div>
      </div>
      <div className={`${styles.discount} ${styles.discount4}`}>
        90<sup>%</sup>
      </div>
    </div>
  );
}

export function MultiPointDiscountTable() {
  return (
    <div className={styles.discountGrid}>
      <div className={`${styles.discountItem} ${styles.discountTitle1}`}>
        Discount
      </div>
      <div className={`${styles.discountItem} ${styles.discountTitle2}`}></div>
      <div className={`${styles.discountItem} ${styles.discountItem1}`}>
        2<sup>nd</sup> point:
      </div>
      <div className={`${styles.discountItem} ${styles.discountItem2}`}>
        50% discount
      </div>
      <div className={`${styles.discountItem} ${styles.discountItem3}`}>
        3<sup>rd</sup>-9<sup>th</sup> point:
      </div>
      <div className={`${styles.discountItem} ${styles.discountItem4}`}>
        75% discount
      </div>
      <div className={`${styles.discountItem} ${styles.discountItem5}`}>
        10<sup>th</sup>+ point:
      </div>
      <div className={`${styles.discountItem} ${styles.discountItem6}`}>
        90% discount
      </div>
    </div>
  );
}

export function DataFileFormatsTable() {
  return (
    <div className={styles.dataFileFormatsTable}>
      <table>
        <thead>
          <tr>
            <th colSpan={5}>Data file formats</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope='col'></td>
            <td scope='col'>.csv (ASCII)</td>
            <td scope='col'>.mat (Matlab)</td>
            <td scope='col'>.nc (NetCDF)</td>
            <td scope='col'>.dfs (MIKE)</td>
          </tr>
          <tr>
            <td scope='row'>Wave</td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
          </tr>
          <tr>
            <td scope='row'>Ocean</td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
          </tr>
          <tr>
            <td scope='row'>Atmosphere</td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
          </tr>
          <tr>
            <td scope='row'>2D Spectra</td>
            <td>
              <div>
                <No />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
          </tr>
          <tr>
            <td scope='row'>3D Currents</td>
            <td>
              <div>
                <No />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
            <td>
              <div>
                <Yes />
              </div>
            </td>
          </tr>
          <tr></tr>
        </tbody>
      </table>
    </div>
  );
}

export function SubscriptionTable({
  handleCloseAllModals,
}: {
  handleCloseAllModals: () => void;
}) {
  const navigate = useNavigate();
  const setDropdownSearchbarOpen = useHomeStore(
    (state) => state.setDropdownSearchbarOpen
  );
  return (
    <div className={styles.subscriptionTable}>
      <div className={`${styles.title} ${styles.title1}`}>Subscriptions</div>
      <div className={`${styles.title} ${styles.title2}`}>ANALYST</div>
      <div className={`${styles.title} ${styles.title3}`}>ADVISOR</div>
      <div className={`${styles.title} ${styles.title4}`}>EXPLORER</div>

      <div className={`${styles.subTitle} ${styles.subTitle1}`}></div>
      <div className={`${styles.subTitle} ${styles.subTitle2}`}>Analytics</div>
      <div className={`${styles.subTitle} ${styles.subTitle3}`}>
        Reports & Analytics
      </div>
      <div className={`${styles.subTitle} ${styles.subTitle4}`}>
        Data, Reports & Analytics
      </div>

      <div className={`${styles.category} ${styles.cat1}`}>Pricing</div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem1}`}>
        <div>
          <div className={styles.itemPrice}>
            &euro;1.500 <div className={styles.monthTag}>/mo</div>
          </div>
        </div>
        <div className={styles.itemSubTitle}>(min. 12 months)</div>
      </div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem2}`}>
        <div>
          <div className={styles.itemPrice}>
            &euro;5.000 <div className={styles.monthTag}>/mo</div>
          </div>
        </div>
        <div className={styles.itemSubTitle}>(min. 12 months)</div>
      </div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItem3}`}>
        <div>
          <div className={styles.itemPrice}>
            &euro;9.000 <div className={styles.monthTag}>/mo</div>
          </div>
        </div>
        <div className={styles.itemSubTitle}>(min. 12 months)</div>
      </div>
      <div className={`${styles.category} ${styles.catNew}`}></div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItemNew1}`}>
        <div>
          <div className={styles.itemPrice}>
            &euro;1.800 <div className={styles.monthTag}>/mo</div>
          </div>
        </div>
        <div className={styles.itemSubTitle}>(min. 3 months)</div>
      </div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItemNew2}`}>
        <div>
          <div className={styles.itemPrice}>Upon request</div>
        </div>
        <div className={styles.itemSubTitle}>(min. 3 months)</div>
      </div>
      <div className={`${styles.OneOffItem} ${styles.OneOffItemNew3}`}>
        <div>
          <div className={styles.itemPrice}>
            &euro;10.800 <div className={styles.monthTag}>/mo</div>
          </div>
        </div>
        <div className={styles.itemSubTitle}>(min. 3 months)</div>
      </div>
      <div
        className={`${styles.subscriptionOptionsTableTitle} ${styles.subscriptionOptionsTableTitle1}`}
      >
        Main Features
      </div>
      <div
        className={`${styles.subscriptionOptionsRowHead} ${styles.subscriptionOptionsRowHead2}`}
      >
        <div>
          Download of time series
          <span
            onClick={() => {
              handleCloseAllModals();
              setDropdownSearchbarOpen(true);
            }}
            className={styles.spanLink}
          >
            {' '}
            datasets{' '}
          </span>
        </div>
        <div>(online only, up to 15 downloads per day)</div>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem4}`}
      >
        <No />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem5}`}
      >
        <No />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem6}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsRowHead} ${styles.subscriptionOptionsRowHead1}`}
      >
        <div>
          Full access to metocean
          <span
            onClick={() => {
              handleCloseAllModals();
              navigate('features#analytics');
            }}
          >
            {' '}
            analytics{' '}
          </span>
        </div>
        <div>(e.g. Weather Windows and Extreme Values)</div>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem1}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem2}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem3}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsRowHead} ${styles.subscriptionOptionsRowHead7}`}
      >
        <div>
          On-demand metocean
          <span
            onClick={() => {
              handleCloseAllModals();
              navigate('features#data-report');
            }}
          >
            {' '}
            data reports{' '}
          </span>
        </div>
        <div>(PDF and Excel, up to 25 reports per year)</div>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem19}`}
      >
        <No />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem20}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem21}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsRowHead} ${styles.subscriptionOptionsRowHead3}`}
      >
        <div>Updates during the subscription</div>
        <div>(e.g. extended datasets and new features)</div>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem7}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem8}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem9}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsRowHead} ${styles.subscriptionOptionsRowHead4}`}
      >
        <div>{`10% discount on 'offline' data`}</div>
        <div>(e.g. 3D Ocean Current and 2D Wave Spectra)</div>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem10}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem11}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem12}`}
      >
        <Yes />
      </div>
      <div
        className={`${styles.subscriptionOptionsRowHead} ${styles.subscriptionOptionsRowHead5}`}
      >
        <div>Multiple user accounts</div>
        <div>(Share the subscription across your business)</div>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem13}`}
      >
        Up to 5
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem14}`}
      >
        Up to 5
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem15}`}
      >
        Up to 5
      </div>
      <div
        className={`${styles.subscriptionOptionsTableTitle} ${styles.subscriptionOptionsTableTitle2}`}
      >
        Added Value
      </div>
      <div
        className={`${styles.subscriptionOptionsTableTitle} ${styles.subscriptionOptionsTableTitle3}`}
      >
        Support
      </div>
      <div
        className={`${styles.subscriptionOptionsRowHead} ${styles.subscriptionOptionsRowHead6}`}
      >
        <div>Support from DHI metocean experts</div>
        <div></div>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem16}`}
      >
        Up to 1 hour <span className={styles.monthTag}> /mo</span>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem17}`}
      >
        Up to 3 hour <span className={styles.monthTag}> /mo</span>
      </div>
      <div
        className={`${styles.subscriptionOptionsItem} ${styles.subscriptionOptionsItem18}`}
      >
        Up to 3 hour <span className={styles.monthTag}> /mo</span>
      </div>
      <div className={styles.sectionContainerFooter}>
        <div className={styles.footerTitle}>General Services</div>
        <div className={styles.footerContent}>
          <div className={styles.footerContentItems}>
            <div>
              <Info className={styles.svg} />
              <p>
                Free access to
                <span
                  onClick={() => {
                    handleCloseAllModals();
                    navigate('features#validation');
                  }}
                >
                  {' '}
                  Validations{' '}
                </span>
              </p>
            </div>
            <p className={styles.footerContentSubText}>
              (comparison againts altimeter and in-situ data)
            </p>
          </div>
          <div className={styles.footerContentItems}>
            <div>
              <Info className={styles.svg} />
              <p>
                <span
                  onClick={() => {
                    handleCloseAllModals();
                    navigate('features#api');
                  }}
                >
                  {' '}
                  API acess{' '}
                </span>
                for download of time series data
              </p>
            </div>
            <p className={styles.footerContentSubText}>
              (see examples for Python and Matlab)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export function HostingTable({
  handleCloseAllModals,
}: {
  handleCloseAllModals: () => void;
}) {
  return (
    <div className={styles.hostingTable}>
      <div className={styles.hostingPrice}>
        <div className={`${styles.OneOffItem} ${styles.OneOffItem1}`}>
          <div>
            <div className={styles.itemPrice}>&euro;10.000 </div>
            <div className={styles.itemTitle}>
              <span>setup fee</span>/per dataset
            </div>
          </div>
        </div>
        <div className={styles.plus}>
          <Plus className={styles.svg} />
        </div>
        <div className={`${styles.OneOffItem} ${styles.OneOffItem2}`}>
          <div>
            <div className={styles.itemPrice}>&euro;5.000 </div>
            <div className={styles.itemTitle}>
              <span>per year</span>/per dataset
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
